import { render, staticRenderFns } from "./SuiteBuilder.vue?vue&type=template&id=77bef350&"
import script from "./SuiteBuilder.vue?vue&type=script&lang=js&"
export * from "./SuiteBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports